import { useMutation } from '@apollo/client';
import { QueryKeys } from '@openx/utils/api/queryKeys.ts';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { DeleteUserDocument } from '../../../../graphql/mutation/users/DeleteUser.generated.tsx';

type UseUserDelete = {
  deleteUser: (id: string) => Promise<void>;
  loading: boolean;
  error?: Error;
};

export const useUserDelete = (): UseUserDelete => {
  const [deleteUserMutation, { loading, error }] = useMutation(DeleteUserDocument, {
    refetchQueries: ['GetUsersList'],
  });
  const queryClient = useQueryClient();

  const deleteUser = useCallback(
    async (id: string): Promise<void> => {
      try {
        await deleteUserMutation({ variables: { id } });
        // refreshes the paginated "Users With Access" list on the Organization Details page
        await queryClient.invalidateQueries({ queryKey: [QueryKeys.ORGANIZATION_USERS] });
      } catch (err) {
        // biome-ignore lint/suspicious/noConsole: logging error in console
        console.error('Error deleting user:', err);
        throw err;
      }
    },
    [deleteUserMutation, queryClient]
  );

  return { deleteUser, error, loading };
};
